import React, { useMemo } from 'react';

// One control where two chip strips used to be.
//
// The strips were drawn against 4 clients and 8 buckets. Production has 5 and
// 68: they wrapped to six rows, stood 217px tall even collapsed, and the desk
// reported the top of the screen as unusable. The requirement underneath them
// was only ever "all buckets together, or one bucket on its own" — which is a
// select, not a strip.
//
// Clients stay selectable as well. Narrowing 1000 rows to one publisher is a
// real use that the bucket list alone would lose, and an optgroup gives it for
// free without costing a second control.
//
// Value encoding is prefixed because a client id and a bucket id are different
// kinds of thing and a bare id could not say which.
export const ALL_SCOPE = '';
export const parseScope = (value) => {
  if (!value) return { clientId: null, bucketId: null };
  const [kind, id] = String(value).split(':');
  if (kind === 'client') return { clientId: id, bucketId: null };
  if (kind === 'bucket') return { clientId: null, bucketId: id };
  return { clientId: null, bucketId: null };
};

export default function ScopeSelect({ options = [], clientId, bucketId, onChange }) {
  const byClient = useMemo(() => {
    const map = new Map();
    for (const o of options) {
      const key = String(o.clientId);
      if (!map.has(key)) map.set(key, { clientId: o.clientId, clientName: o.clientName, buckets: [] });
      map.get(key).buckets.push(o);
    }
    return [...map.values()];
  }, [options]);

  const value = bucketId ? `bucket:${bucketId}` : (clientId ? `client:${clientId}` : ALL_SCOPE);

  return (
    <label className="pbnew-ip-scope">
      <span className="pbnew-ip-scope-label">Bucket</span>
      <select
        className="pbnew-select"
        aria-label="Limit to a client or bucket"
        value={value}
        onChange={(e) => onChange(parseScope(e.target.value))}
      >
        <option value={ALL_SCOPE}>All buckets</option>
        {byClient.map((c) => (
          <optgroup key={String(c.clientId)} label={c.clientName}>
            <option value={`client:${c.clientId}`}>{c.clientName} — all buckets</option>
            {c.buckets.map((b) => (
              <option key={String(b.bucketId)} value={`bucket:${b.bucketId}`}>
                {b.name}
                {b.count ? ` (${b.count})` : ''}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
    </label>
  );
}
